import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/Home.vue"),
  },
  {
    path: "/list",
    name: "List",
    component: () => import("@/views/List.vue"),
  },
  {
    path: "/detail",
    name: "Detail",
    component: () => import("@/views/Detail.vue"),
  },
  {
    path: "/reserve",
    name: "Reserve",
    component: () => import("@/views/Reserve.vue"),
  },
  // 数据平台1
  {
    path: "/index",
    name: "Index",
    component: () => import("@/views/dataPlatform/index.vue"),
  },
  {
    path: "/list/data",
    name: "list",
    component: () => import("@/views/dataPlatform/list.vue"),
  },
  {
    path: "/detailData",
    name: "detail",
    component: () => import("@/views/dataPlatform/detail.vue"),
  },
  // 数据平台2
  {
    path: "/dataPlatform2/index",
    name: "dataPlatform2Index",
    component: () => import("@/views/dataPlatform2/index.vue"),
  },
  {
    path: "/dataPlatform2/list",
    name: "dataPlatform2List",
    component: () => import("@/views/dataPlatform2/list.vue"),
  },
  {
    path: "/dataPlatform2/detail",
    name: "dataPlatform2Detail",
    component: () => import("@/views/dataPlatform2/detail.vue"),
  },
  // 数据平台3
  {
    path: "/dataPlatform3/index",
    name: "dataPlatform3Index",
    component: () => import("@/views/dataPlatform3/index.vue"),
  },
  {
    path: "/dataPlatform3/list",
    name: "dataPlatform3List",
    component: () => import("@/views/dataPlatform3/list.vue"),
  },
  {
    path: "/dataPlatform3/detail",
    name: "dataPlatform3Detail",
    component: () => import("@/views/dataPlatform3/detail.vue"),
  },
  // 数据平台4
  {
    path: "/dataPlatform4/index",
    name: "dataPlatform4Index",
    component: () => import("@/views/dataPlatform4/index.vue"),
  },
  // {
  //   path: "/dataPlatform4/list",
  //   name: "dataPlatform4List",
  //   component: () => import("@/views/dataPlatform4/list.vue"),
  // },
  // {
  //   path: "/dataPlatform4/detail",
  //   name: "dataPlatform4Detail",
  //   component: () => import("@/views/dataPlatform4/detail.vue"),
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
